/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import FormField from "../FormField";
import DefaultItem from "../../../../../../views/Items/DefaultItem";
import {parseISO} from "date-fns";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import WebsiteIcon from "@mui/icons-material/Web";
import {Face} from "@mui/icons-material";
import Link from "@mui/material/Link";
import WebIcon from "@mui/icons-material/Web";

// EditProduct page components

function Socials({website, twitter, facebook, instagram}) {

  return (
      <Card>
        <MDBox pt={2} px={2} lineHeight={1}>
          <MDTypography variant="h6" fontWeight="medium">
            Socials
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <DefaultItem
              color="info"
              icon={<WebsiteIcon/>}
              title="Website"
              description={website}
              clickable
          />
          <MDBox mt={2.5}>
            <DefaultItem
                color="info"
                icon={<TwitterIcon/>}
                title="Twitter"
                description={twitter}
                clickable
            />
          </MDBox>
          <MDBox mt={2.5}>
            <DefaultItem
                color="info"
                icon={<FacebookIcon/>}
                title="Facebook"
                description={facebook}
                clickable
            />
          </MDBox>
          <MDBox mt={2.5}>
          <DefaultItem
              color="info"
              icon={<InstagramIcon/>}
              title="Instagram"
              description={instagram}
              clickable
          />
        </MDBox>
        </MDBox>
      </Card>
  );
}

export default Socials;
